export const HISTORY_CAMERAS = [
  "dateTime",
  "cameraId",
  "cameraName",
  "typeEvent",
  "comment",
  "user",
];
